export default __webpack_public_path__ + "static/media/banner3.192a19a7.png";